export const dashboardEndpoint = {
    // Dashboards
    coordenador: `/api/v1/dashboard/coordenador`,
    // Os 6 blocos do painel Gestor numa resposta só; `atualizar` ignora o cache do servidor (até 5 min)
    painelGestor: (ano, atualizar = false) => `/api/v1/dashboard/painel-gestor?ano=${ano}${atualizar ? '&atualizar=true' : ''}`,
    projetosPorStatus: `/api/v1/dashboard/projetos-por-status`,
    doaPorAno: `/api/v1/dashboard/doa-por-ano`,
    desembolsoPorAno: `/api/v1/dashboard/desembolsos-por-ano`,
    pagamentosBolsaPorAno: `/api/v1/dashboard/pagamentos-bolsas-por-ano`,
    totalContratacoesPorStatus: `/api/v1/dashboard/contratacoes-por-status`,
    metricasCompras: `/api/v1/dashboard/metricas-compras`,
    captacao: `/api/v1/dashboard/captacao`,
    pagamentosRealizadosPorAno: `/api/v1/dashboard/pagamentos-realizados-por-ano`,
    pagamentosCltsPorAno: `/api/v1/dashboard/pagamentos-clts-por-ano`,
    metricasClt: `/api/v1/dashboard/metricas-clt`,
    metasSolicitacoes: (projetoId) => `/api/v1/dashboard/projeto/${projetoId}/metas-solicitacoes`,
    analistaProjetos: `/api/v1/dashboard/analista-projeto`,
    ordenadorDespesas: `/api/v1/dashboard/ordenador-despesas`,
    analistaFinanceiro: `/api/v1/dashboard/analista-financeiro`,
    obrigacoesFiscais: `/api/v1/dashboard/obrigacoes-fiscais`,
    chefiaSetor: (setorId) => `/api/v1/dashboard/chefia-setor/${setorId}`,
    projetosPorAnalista: `/api/v1/dashboard/chefia-projetos/projetos-por-analista`,
    tempoMedioAvaliacao: `/api/v1/dashboard/chefia-projetos/tempo-medio-avaliacao`,

}
